import Hero from '../components/hero/Hero'
import LiquidBackground from '../components/hero/LiquidBackground'
import ProofBar from '../components/proof/ProofBar'
import Reframe from '../components/reframe/Reframe'
import TokenVsValue from '../components/value/TokenVsValue'
import UnlimitedTokens from '../components/unlimited/UnlimitedTokens'
import UnlimitedContext from '../components/unlimited/UnlimitedContext'
import PredictableEconomics from '../components/economics/PredictableEconomics'
import Guarantee from '../components/guarantee/Guarantee'
import DataSecurity from '../components/security/DataSecurity'
import IntelligenceProductivity from '../components/productivity/IntelligenceProductivity'
import Benchmark from '../components/benchmark/Benchmark'
import FinalCta from '../components/cta/FinalCta'

export default function HomePage({ onBurnChange }) {
  return (
    <main>
      <Hero liquidBackground={<LiquidBackground />} />
      <ProofBar />
      <Reframe />
      <TokenVsValue />
      <UnlimitedTokens />
      <UnlimitedContext />
      <PredictableEconomics />
      <Guarantee onBurnChange={onBurnChange} />
      <DataSecurity />
      <IntelligenceProductivity />
      <Benchmark />
      <FinalCta />
    </main>
  )
}
